<template>
	<div class="container">
		<div class="row">
			<div class="col-12">
				<div v-if="component.show_title" class="my-2">
					<h3>{{ component.title }}</h3>
				</div>
			</div>
		</div>
		<div class="row">
			<div
					:class="{
						'col-12 col-md-6 col-lg-4 py-2' : component.data.type === AdvertCardTypeEnum.VERTICAL_BIG,
					 	'col-12 py-2': component.data.type === AdvertCardTypeEnum.HORIZONTAL,
					 	'col-12 col-md-4 col-lg-3 py-2': component.data.type === AdvertCardTypeEnum.VERTICAL_SMALL
					}"
					v-for="advert in component.data.items"
			>
				<advert-card-vertical v-if="component.data.type === AdvertCardTypeEnum.VERTICAL_BIG" :advert="advert"/>
				<advert-card-vertical-small v-if="component.data.type === AdvertCardTypeEnum.VERTICAL_SMALL"
											:advert="advert"/>
				<advert-card-horizontal v-if="component.data.type === AdvertCardTypeEnum.HORIZONTAL" :advert="advert"/>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import AdvertCardVertical from "../Components/AdvertCardVertical.vue";
import AdvertCardVerticalSmall from "../Components/AdvertCardVerticalSmall.vue";
import AdvertCardHorizontal from "../Components/AdvertCardHorizontal.vue";
import {AdvertCardTypeEnum} from "../Enums/AdvertCardTypeEnum";
import {PageComponentClass, PageComponentInterface} from "../Interfaces/PageComponentInterface";

export default defineComponent({
	name: "AdvertCardSection",
	computed: {
		AdvertCardTypeEnum() {
			return AdvertCardTypeEnum
		}
	},
	components: {AdvertCardVertical, AdvertCardVerticalSmall, AdvertCardHorizontal},
	props: {
		component: {
			type: Object as PropType<PageComponentInterface>,
			default: new PageComponentClass(),
			required: true,
		}
	}
});
</script>

<style scoped>

</style>
